import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumericFormat } from "react-number-format";
import { usePlausible } from "next-plausible";
import AnimateHeight from "react-animate-height";
import { ChevronDown } from "react-feather";
import { PortableText } from "@portabletext/react";
import { FormWrapper, CauseAreaTitle, CauseAreaContext, TotalSumWrapper, SumWrapper, SumButtonsWrapper, RolloutAccordion } from "../AmountPane.style";
import { MultipleCauseAreaIcon } from "../SelectionPane.style";
import { CauseArea } from "../../../types/CauseArea";
import { ShareType } from "../../../types/Enums";
import { setSmartDistributionTotal } from "../../../store/donation/actions";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { thousandize } from "../../../../../../../util/formatting";
import { State } from "../../../store/state";
import { CauseAreaDisplayConfig, SmartDistributionContext } from "../../../types/WidgetProps";
import { CauseAreaRollout } from "../../shared/CauseAreaRollout/CauseAreaRollout";
import { Links } from "../../../../../../main/blocks/Links/Links";
interface SmartDistributionFormProps {
  suggestedSums: Array<{
    amount: number;
    subtext?: string;
  }>;
  totalAmount: number;
  causeAreas: CauseArea[];
  causeAreaAmounts: Record<number, number>;
  causeAreaDistributionType: Record<number, ShareType>;
  showOperationsOption?: boolean;
  smartDistributionContext: SmartDistributionContext;
  causeAreaDisplayConfig: CauseAreaDisplayConfig;
}
export const SmartDistributionForm: React.FC<SmartDistributionFormProps> = t0 => {
  const $ = _c(47);
  const {
    suggestedSums,
    causeAreaDisplayConfig,
    smartDistributionContext
  } = t0;
  const dispatch = useDispatch();
  const plausible = usePlausible();
  const [explanationOpen, setExplanationOpen] = useState(false);
  let t1;
  if ($[0] !== causeAreaDisplayConfig?.cause_area_rollouts) {
    t1 = causeAreaDisplayConfig?.cause_area_rollouts?.some(_temp);
    $[0] = causeAreaDisplayConfig?.cause_area_rollouts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasSmartDistributionRollout = Boolean(t1);
  const smartDistributionTotal = useSelector(_temp2) || 0;
  let t2;
  if ($[2] !== dispatch || $[3] !== plausible) {
    t2 = suggestedAmount => {
      plausible("SelectSuggestedSum", {
        props: {
          sum: suggestedAmount
        }
      });
      dispatch(setSmartDistributionTotal(suggestedAmount));
    };
    $[2] = dispatch;
    $[3] = plausible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSuggestedSumClick = t2;
  let t3;
  if ($[5] !== dispatch) {
    t3 = (values, sourceInfo) => {
      if (sourceInfo.source !== "event") {
        return;
      }
      const v = values.floatValue === undefined ? 0 : values.floatValue;
      dispatch(setSmartDistributionTotal(v));
    };
    $[5] = dispatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleTotalAmountChange = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MultipleCauseAreaIcon />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== smartDistributionContext.smart_distribution_title) {
    t5 = <CauseAreaTitle>{t4}{smartDistributionContext.smart_distribution_title}</CauseAreaTitle>;
    $[8] = smartDistributionContext.smart_distribution_title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== causeAreaDisplayConfig) {
    t6 = getCauseAreaContext(-1, causeAreaDisplayConfig);
    $[10] = causeAreaDisplayConfig;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <CauseAreaContext>{t6}</CauseAreaContext>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div>{t5}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleSuggestedSumClick || $[18] !== smartDistributionTotal || $[19] !== suggestedSums) {
    let t10;
    if ($[21] !== handleSuggestedSumClick || $[22] !== smartDistributionTotal) {
      t10 = suggested => <div key={suggested.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={smartDistributionTotal === suggested.amount} onClick={() => handleSuggestedSumClick(suggested.amount)} noMinWidth={true} cy={`suggested-sum-smart-${suggested.amount}`}>{`${suggested.amount ? thousandize(suggested.amount) : "-"} kr`}</EffektButton>{suggested.subtext && <i>{suggested.subtext}</i>}</div>;
      $[21] = handleSuggestedSumClick;
      $[22] = smartDistributionTotal;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    t9 = suggestedSums.map(t10);
    $[17] = handleSuggestedSumClick;
    $[18] = smartDistributionTotal;
    $[19] = suggestedSums;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <SumButtonsWrapper>{t9}</SumButtonsWrapper>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = smartDistributionTotal > 0 ? smartDistributionTotal : "";
  let t12;
  if ($[26] !== handleTotalAmountChange || $[27] !== t11) {
    t12 = <SumWrapper><span><NumericFormat name="sum" thousandSeparator=" " allowNegative={false} decimalScale={0} type="tel" placeholder="0" value={t11} autoComplete="off" data-cy="donation-sum-input-overall" onValueChange={handleTotalAmountChange} /></span></SumWrapper>;
    $[26] = handleTotalAmountChange;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t12) {
    t13 = <div><TotalSumWrapper>{t10}{t12}</TotalSumWrapper></div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== explanationOpen || $[33] !== hasSmartDistributionRollout || $[34] !== smartDistributionContext.smart_distribution_description || $[35] !== smartDistributionContext.smart_distribution_description_links || $[36] !== smartDistributionContext.smart_distribution_label_text) {
    t14 = !hasSmartDistributionRollout && smartDistributionContext.smart_distribution_description && <RolloutAccordion><div onClick={() => setExplanationOpen(!explanationOpen)}><span>{smartDistributionContext.smart_distribution_label_text}</span><ChevronDown size={28} style={{
          transform: explanationOpen ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.3s ease"
        }} /></div><AnimateHeight height={explanationOpen ? "auto" : 0}><div><PortableText value={smartDistributionContext.smart_distribution_description} />{smartDistributionContext.smart_distribution_description_links && <Links links={smartDistributionContext.smart_distribution_description_links} />}</div></AnimateHeight></RolloutAccordion>;
    $[32] = explanationOpen;
    $[33] = hasSmartDistributionRollout;
    $[34] = smartDistributionContext.smart_distribution_description;
    $[35] = smartDistributionContext.smart_distribution_description_links;
    $[36] = smartDistributionContext.smart_distribution_label_text;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== causeAreaDisplayConfig) {
    t15 = <CauseAreaRollout causeAreaId={-1} config={causeAreaDisplayConfig} />;
    $[38] = causeAreaDisplayConfig;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t14 || $[41] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t13 || $[44] !== t16 || $[45] !== t8) {
    t17 = <FormWrapper>{t8}{t13}{t16}</FormWrapper>;
    $[43] = t13;
    $[44] = t16;
    $[45] = t8;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
};
const getCauseAreaContext = (id: number, config?: CauseAreaDisplayConfig) => {
  const context = config?.cause_area_contexts?.find(c => c.cause_area_id === id);
  return context?.context_text || null;
};
function _temp(item) {
  return item.cause_area_id === -1 && item.title;
}
function _temp2(state) {
  return state.donation.smartDistributionTotal;
}